















































import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import * as firebase from 'firebase/app';
import AnnouncementForm from "@/forms/AnnouncementForm.vue";
import CompanyAnnouncement from "@/components/company/CompanyAnnouncement.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import {ESettori} from "@/types";
import EventBus from "@/EventBus";

@Component({
    components: {ConfirmModal, AnnouncementForm, CompanyAnnouncement},
    computed: {
        ...mapGetters({user: 'user', announcements: 'announcements'})
    },
    name: "CompanyAnnouncements"
})
export default class CompanyAnnouncements extends Vue {
    private user?: any;
    private modal_show: boolean = false;
    private showing_action_id:string = '';

    created(){
        EventBus.$on('ca:menu_close', ()=>{this.showAction = ''})
    }

    get modalShow() {
        return this.modal_show;
    }

    get showAction(){
        return this.showing_action_id;
    }
    set showAction(val:string){
        this.showing_action_id = val
    }

    private handleFilter(event:Event){
        this.$emit('filter' ,event)
        this.showAction = ''
    }
    private handleEdit(id:string){
        this.$router.push({name: 'EditAnnouncement', params: {announcementUuid: id}})
        this.showAction = ''
    }

    set modalShow(val: boolean) {
        if (!val) {
            (this.$refs.modal as Vue).$off('si');
            (this.$refs.modal as Vue).$off('no');
        }
        this.modal_show = val;
    }


    private deleteAnnouncement(announcement_id: string) {
        this.showAction = ''
        new Promise((resolve, reject) => {
            (this.$refs.modal as Vue).$once('si', resolve);
            (this.$refs.modal as Vue).$once('no', reject);
            this.modalShow = true;
        }).then(() => {
            firebase.firestore()
                .collection('users')
                .doc(this.user.id).collection('announcements').doc(announcement_id).delete()
        }).catch(() => {
        }).finally(() => {
            this.modalShow = false
        })
    }

}

